import { render, staticRenderFns } from "./DeleteTemplateSchoolForGroupDialog.vue?vue&type=template&id=4e1389f0&scoped=true"
import script from "./DeleteTemplateSchoolForGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateSchoolForGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateSchoolForGroupDialog.vue?vue&type=style&index=0&id=4e1389f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1389f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1389f0')) {
      api.createRecord('4e1389f0', component.options)
    } else {
      api.reload('4e1389f0', component.options)
    }
    module.hot.accept("./DeleteTemplateSchoolForGroupDialog.vue?vue&type=template&id=4e1389f0&scoped=true", function () {
      api.rerender('4e1389f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByGroup/TableSearchGroupDialog/DeleteTemplateSchoolForGroupDialog.vue"
export default component.exports